import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { fuseAnimations } from "@fuse/animations";
import { FuseConfirmDialogComponent } from "@fuse/components/confirm-dialog/confirm-dialog.component";
import { UiService } from "app/helper-components/UiService";
import { PostService } from "app/helpers/post.service";
import { environment } from "environments/environment";

@Component({
  selector: "app-edit-vots",
  templateUrl: "./edit-vots.component.html",
  styleUrls: ["./edit-vots.component.scss"],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
})
export class EditVotsComponent implements OnInit {
  data: any;
  selfvots: any = "";
  opp_1: any = "";
  opp_2: any = "";
  total: any = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialog_param: any,
    public dialogRef: MatDialogRef<FuseConfirmDialogComponent>,
    private uiService: UiService,
    private postService: PostService,
  ) {
    this.data = dialog_param;
  }

  ngOnInit(): void {
    this.autobind();
  }

  autobind() {
    this.selfvots = this.data[0].self;
    this.opp_1 = this.data[0].opp_1;
    this.opp_2 = this.data[0].opp_2;
    this.total = this.data[0].total_votes;
  }

  edit() {
    const formData = new FormData();

    formData.append("contest_id", this.data[0].contest_id);
    formData.append("ward_booth_id", this.data[0].ward_booth_id);
    formData.append("self", this.selfvots);
    formData.append("opp_1", this.opp_1);
    formData.append("opp_2", this.opp_2);
    formData.append("total_votes", this.total);

    if (this.data[0].votes_id != null) {
      formData.append("updateVoteCount", "1");
      formData.append("votes_id", this.data[0].votes_id);
    } else {
      formData.append("addVoteCount", "1");
    }

    this.postService.post(environment.API_VOTES, formData).subscribe((val) => {
      this.dialogRef.close({
        data: val,
        selfvots: this.selfvots,
        opp_1: this.opp_1,
        opp_2: this.opp_2,
        total: this.total,
      });
      this.uiService.hideLoading();
    });
  }
}
